module.exports = __webpack_public_path__ + "static/img/cheliangjianguan.b16a98dc.png";